import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { postApiCall } from "../../../service/httpCall";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { API_REMARK_STATUS_CREATE } from "../../../service/url";
import {STATUS} from "../../../utilities/constant";


const RemarkStatusCreate = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [remark, setRemarks] = useState("");
  const [status, setStatus] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);


  function validateForm() {
    let valid = true;
    if (!remark.trim()) {
      valid = false;
      toast.warning("Remark is required")
    }

     if (!status) {
      valid = false;
      toast.warning("Status is required")
    }
    
    
    return valid;
}
  

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    const params = {remark:remark, status: Number(status)
    };
    postApiCall(API_REMARK_STATUS_CREATE, params)
    .then(onRemarkStatusCreateSuccess)
    .catch(onRemarkStatusCreateError);

}

function onRemarkStatusCreateSuccess(resp) {
    toast.success("Remark Status created successfully")
    setTimeout(() => {
       navigate(`/${ROUTES.REMARKS.LIST}`);
    }, 1500);
 }

  function onRemarkStatusCreateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     setButtonDisable(false);
     toast.warning(JSON.stringify(err))
   }
  }

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">New Remark Status Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Remark <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          id="remark"
                          placeholder="Remarks"
                          maxLength={100}
                          value={remark}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                            setRemarks(value);
                          }}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Status <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Select
                          id="status"
                          className="p-2"
                          required
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option value={""}>Status</option>
                          {STATUS.map(function (val, idx) {
                            return (
                              <option key={idx} value={val.value}>
                                {val.label}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </div>

          
                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable}
                    >
                      Add Remark Status &nbsp;
                      {buttonDisable ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};
export default RemarkStatusCreate;
